import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import AppIcon from '../images/icon.png'
//* Material UI
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

//* Redux
import { useDispatch, useSelector } from 'react-redux'
import { loginUser } from '../redux/actions/userActions'

const styles = (theme) => ({
  ...theme.spreadThis,
})

const Login = ({ classes }) => {
  //* History
  const history = useHistory()
  console.log(history)
  //* State
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  //* Redux
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.UI)

  //* Event Handlers
  const handleSubmit = (e) => {
    e.preventDefault()
    const userData = {
      email,
      password,
    }
    dispatch(loginUser(userData, history))
  }

  return (
    <Grid container className={classes.form}>
      <Grid item sm />
      <Grid item sm>
        <img src={AppIcon} alt='bird' className={classes.image} />
        <Typography variant='h2' className={classes.pageTitle}>
          Login
        </Typography>
        <form noValidate onSubmit={handleSubmit}>
          <TextField
            id='email'
            name='email'
            type='email'
            label='Email'
            autoComplete='username'
            className={classes.textField}
            // helperText={errors.email}
            // error={errors.email ? true : false}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
          <TextField
            id='password'
            name='password'
            type='password'
            label='Password'
            autoComplete='current-password'
            className={classes.textField}
            // helperText={errors.password}
            // error={errors.password ? true : false}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          {/* {errors && (
            <Typography variant='body2' className={classes.customError}>
              {errors.general}
            </Typography>
          )} */}
          <Button
            type='submit'
            variant='contained'
            color='primary'
            className={classes.button}
            disabled={loading}
          >
            Login
            {loading && (
              <CircularProgress size={30} className={classes.progress} />
            )}
          </Button>
          <br />
          <small>
            Don't have an account? <Link to='/signup'>Sign Up</Link>{' '}
          </small>
        </form>
      </Grid>
      <Grid item sm />
    </Grid>
  )
}

export default withStyles(styles)(Login)
